import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
	path: '/',
	name: 'Home',
	component: Home
}, {
	path: "/onestukq",
	name: "onestukq",
	component: () => import("../views/onestukq.vue")
},
{
	path: "/dangan",
	name: "dangan",
	component: () => import("../views/kf/dangan.vue")
},
{
	path: "/dangan",
	name: "dangan",
	component: () => import("../views/kf/dangan.vue")
},
{
	path: "/dangan_zt",
	name: "dangan_zt",
	component: () => import("../views/kf/stu_dangan_zt.vue")
},
{
	path: "/dangan_shili",
	name: "dangan_shili",
	component: () => import("../views/kf/stu_dangan_shili.vue")
},
{
	path: "/dangan_tlyy",
	name: "dangan_tlyy",
	component: () => import("../views/kf/stu_dangan_tlyy.vue")
},
{
	path: '/kfprint',
	name: 'kfprint',
	component: () => import('../views/kfprint.vue')
},
{
	path: '/login',
	name: 'login',
	component: () => import('../views/login.vue')
}, {
	path: '/admin',
	name: 'admin',
	component: () => import('../views/frames.vue'),
	children: [{
		path: "zonglan",
		name: "zonglan",
		component: () => import("../views/zonglan.vue")
	}, {
		path: "onething",
		name: "onething",
		component: () => import("../views/onething.vue")
	},
	{
		path: 'kangfu',
		name: 'kangfu',
		component: () => import('../views/kangfu.vue')
	}, {
		path: "setting",
		name: "setting",
		component: () => import("../views/setting.vue")
	}, {
		path: "settinguser",
		name: "settinguser",
		component: () => import("../views/settinguser.vue")
	}, {
		path: "taskList",
		name: "taskList",
		component: () => import("../views/association/task/list.vue")
	}, {
		path: "taskDetail",
		name: "taskDetail",
		component: () => import("../views/association/task/detail.vue")
	},
	{
		path: "resultList",
		name: "resultList",
		component: () => import("../views/association/result/list.vue")
	},
	{
		path: "conditionList",
		name: "conditionList",
		component: () => import("../views/association/result/conditionList.vue")
	}, {
		path: "canxieManage",
		name: "canxieManage",
		component: () => import("../views/canxieManage.vue")
	},
	{
		path: "chizheng",
		name: "chizheng",
		component: () => import("../views/chizheng.vue")
	},
	{
		path: "extensionList",
		name: "extensionList",
		component: () => import("../views/association/extension/index.vue")
	}, {
		path: "activityList",
		name: "activityList",
		component: () => import("../views/association/activity/index.vue")
	}, {
		path: "statistics",
		name: "statistics",
		component: () => import("../views/association/result/statistics.vue")
	}, {
		path: "companyList",
		name: "companyList",
		component: () => import("../views/agency/company/list.vue")
	}, {
		path: "companyUserList",
		name: "companyUserList",
		component: () => import("../views/agency/user/list.vue")
	}, {
		path: "policyList",
		name: "policyList",
		component: () => import("../views/agency/policy/list.vue")
	}

	]
}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
